<template>
  <div class="warp">
    <div class="headwarp">

      <div class="head">
        <div class="logo"> <img src="../assets/images/logo.png" /></div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="mainwarp">
      <div class="main">
        <div class="right">
          <div class="loginwarp">
            <div class="loginhead"><b>欢迎登录供应商协同平台</b></div>
            <!-- 登录表单区域 -->
            <!-- ref 创建了一个loginForm实例对象 -->
            <div class="loginbody">
              <p class="loginp"><b><i class="el-icon-message"></i>致认养一头牛供应商伙伴</b>
                <span @click="makejz()">【点击了解认养一头牛廉正】</span>
              </p>
              <el-form :model="loginForm" :rules="rules" ref="loginFormref">
                <!-- 登录账号 -->
                <div class="itemmd">
                  <el-form-item prop="username">
                    <el-input placeholder="请输入账号" prefix-icon="iconfont icon-yonghuming" v-model="loginForm.username" autocomplete="on"></el-input>
                  </el-form-item>
                </div>
                <!-- 登录密码-->
                <div class="itemmd">
                  <el-form-item prop="password">
                    <el-input placeholder="请输入密码" prefix-icon="iconfont icon-iconfontcolor10-copy" v-model="loginForm.password" :type="pwdType" @keyup.enter.native="login(loginForm)">
                      <span slot="suffix" class="iconfont" :class="icon" @click="showPwd()" style="margin-right: 5px"></span>
                    </el-input>
                  </el-form-item>
                </div>

                <div class="itemmdbtn">

                  <el-button type="success" size="large" @click="login(loginForm)">登录</el-button>
                </div>
                <!-- 重置 -->
                <!-- <el-form-item>
            <el-button type="primary" size="large" @click="resetloginForm">重置</el-button>
          </el-form-item>-->
                <div class="itemmd">

                  <span class="pull-right" style="margin-right:15px" @click="upassword()">忘记密码</span>
                  <router-link :to="{path:'/dlxxregister', params: {id:1}}" class="pull-right" style="margin-right:15px">注册</router-link>
                </div>

              </el-form>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="is-with-footer el-dialog--center foot">
      <P>
        Copyright © 2012-2021 山东亿盖普信息科技有限公司
      </P>

    </div>

    <Imgtd v-if="visible" :visib="visible" @isshow="vishow" />
    <forgetpassword v-if="disvisible" :disvisible="disvisible" @fgtpaw="fgtpaw" />
  </div>
</template>
<script>
import Imgtd from "../components/vail/Imgtd";
import forgetpassword from "./main-navbar-forget-password.vue";
export default {
  components: {
    Imgtd,
    forgetpassword,
  },
  data() {
    return {
      pwdType: "password",
      icon: "icon-pwd-hide",
      //登陆表单绑定对象
      loginForm: {
        username: "",
        password: "",
      },
      checked: true,
      disvisible: false,
      visible: false,
      viscont: 0,
      //表单的验证规则对象
      rules: {
        //失去焦点时候验证用户名
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        //失去焦点时候验证密码
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getCookie();
    if (localStorage.username) {
      this.loginForm = {
        username: localStorage.username,
        password: localStorage.password,
      };
    }
  },
  methods: {
    fgtpaw(val) {
      this.disvisible = val;
    },
    //忘记密码
    upassword() {
      this.disvisible = true;
      console.log(this.disvisible);
    },
    // 是否显示图片imgtd
    vishow(val) {
      this.visible = val;
    },
    //密码的隐藏和显示
    showPwd() {
      //三目运算
      this.pwdType = this.pwdType === "password" ? "text" : "password";
      this.icon =
        this.icon === "icon-xianshi" ? "icon-pwd-hide" : "icon-xianshi";
    },
    //点击重置按钮，表单重置
    resetloginForm() {
      this.$refs.loginFormref.resetFields();
    },
    makejz() {
      window.open("https://www.aliwork.com/o/ygytn");
    },
    login: _.debounce(function (formName) {
      this.logind(formName);
    }, 500),
    // login(formName):_.debounce(function () { {
    //     // this._.debounce(,1000,false)
    //     },1000,false),

    // //登录预验证
    logind(formName) {
      // this.$router.push("/home");
      //与后端请求代码，本功能不需要与后台交互所以省略
      this.$refs.loginFormref.validate(async (valid) => {
        if (!valid) return;
        const data = {
          username: formName.username,
          password: formName.password,
        };
        console.log(data);
        const { data: res } = await this.$axios.post(
          "CommonModule/WebAuthen/LoginSRM",
          { username: formName.username, password: formName.password }
        );
        console.log(res);
        if (res.Success) {
          this.GetLogInfo(res.Data);
          window.localStorage.setItem("token", res.Data);
        } else {
          this.$message.error(res.Message);
          if (res.Code == "1") {
            this.$router.push({
              path: "/useregister",
              query: { id: res.Data },
            });
          } else if (res.Code == "2") {
            // this.$router.push({ path: "/SupplyObject", query: { id: res.Data } });
          } else if (res.Code == "2") {
            // this.$router.push({ path: "/Qualification", query: { id: res.Data } });
          }
        }
      });
    },
    // 获取信息
    GetLogInfo(data) {
      this.$axios({
        method: "post",
        url: "CommonModule/WebAuthen/GetLoginInfo",
        data: { ticket: data },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          window.localStorage.setItem(
            "userdata",
            JSON.stringify(res.data.Data[0])
          );

          this.$store.commit("userdata", res.data.Data[0]);
          this.$router.push("/home");
        } else {
          this.$message.error(res.data.Message);
          this.form.cnote = "";
        }
      });
    },
    //设置cookie的值
    setCookie(c_name, c_pwd, c_check, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      document.cookie =
        "userName=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "userPwd=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "checkof=" + c_check + ";path=/;expires=" + exdate.toLocaleString();
    },
    //获取cookie的值
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        // console.log(arr)
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.loginForm.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.loginForm.password = arr2[1];
          } else if (arr2[0] == "checkof") {
            this.checked = arr2[1];
            if (arr2[1] != "") {
              this.checked = eval(arr2[1].toLowerCase());
            }
          }
        }
      }
    },
    //删除cookie
    clearCookie: function () {
      this.setCookie("", "", "", -1); //修改2值都为空，天数为负1天就好了
    },
    // 上传图片规格
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        return this.$message.error("上传文件只能是 JPG或PNG 格式!");
      }
      if (!isLt2M) {
        return this.$message.error("上传图片大小不能超过 5MB!");
      }
      return upQiniu(this.bucketQuery).then((res) => {
        this.form = {
          token: res.data,
        };
      });
    },
    //图片改变及上传
    bannerPicChange(value) {
      this.fileList1 = [];
      this.fileList1.push({
        name: value,
        url: value,
      });
    },
    handleBannerPicRemove(file, fileList) {
      this.fileList1 = [];
      this.listVideoQuery.orgLogo = "";
    },
    handleAvatarSuccess(response) {
      if (this.upPicName == "orgLogo") {
        this.fileList1 = [];
        this.fileList1.push({
          name: "http://" + this.qiniuaddr + "/" + response.key,
          url: "http://" + this.qiniuaddr + "/" + response.key,
        });
        this.listVideoQuery.orgLogo =
          "http://" + this.qiniuaddr + "/" + response.key;
      }
      this.$message({
        type: "success",
        message: "上传成功!",
        duration: 2000,
      });
    },
    orgLogoChange() {},
  },
};
</script>
<style scoped>
@import url(../assets/css/login.css);
</style>